<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md12>
				<filter-driver
					v-model="filter"
					@filter="onFilter()"
				></filter-driver>
			</v-flex>
			<v-flex xs12>
				<app-datatable
					:title="$t('title.driver_datatable')"
					:endpoint="endpoint"
					:data="data"
					:headers="headers"
					:filter="filter"
					@onEdit="editItem"
					@onDelete="deleteItem"
					@onView="viewItem"
					:hasView="true"
				>
					<template v-slot:[`item.image`]="{ item }">
						<app-thumbnail-placeholder
							v-model="item.image"
						></app-thumbnail-placeholder>
					</template>
					<template v-slot:[`item.status`]="{ item }">
						<v-chip
							color="light-blue darken-1"
							dark
							v-if="item.status == 'assign'"
							small
							>{{ $t("label.assign") }}</v-chip
						>
						<v-chip
							color="teal darken-4"
							dark
							v-if="item.status == 'on_duty'"
							small
							>{{ $t("label.on_duty") }}</v-chip
						>
						<v-chip
							color="orange darken-3"
							dark
							v-if="item.status == 'available'"
							small
							>{{ $t("label.available") }}</v-chip
						>
						<v-chip
							color="rea darken-3"
							dark
							v-if="item.status == 'day_off'"
							small
							>{{ $t("label.day_off") }}</v-chip
						>
					</template>
					<template v-slot:[`item.active`]="{ item }">
						<app-active-button
							v-model="item.active"
						></app-active-button>
					</template>
				</app-datatable>
			</v-flex>
		</v-layout>
		<app-create-fab-button
			@click="
				$inertia.visit(
					$route('tenant.drivers.create', $page.props.tenant.id)
				)
			"
		></app-create-fab-button>
		<app-tenant-delete-dialog
			ref="deleteDialog"
			:endpoint="'tenant.drivers.destroy'"
			:uuid="item.uuid"
			:data="{
				driver: item.uuid,
				tenant: $page.props.tenant.id,
			}"
		></app-tenant-delete-dialog>
	</v-container>
</template>
<script>
import pickBy from "lodash/pickBy";
export default {
	props: ["data"],
	data() {
		return {
			filter: {},
			item: {},
		};
	},
	computed: {
		endpoint() {
			return this.$route(
				"tenant.drivers.index",
				this.$page.props.tenant.id
			);
		},
		headers() {
			return [
				{
					text: this.$t("Action"),
					value: "actions",
					sortable: false,
					searchable: false,
					align: "left",
					width: 80,
				},
				{
					text: this.$t("Image"),
					value: "image",
					align: "left",
					sortable: false,
					width: 100,
				},
				{
					text: this.$t("Name"),
					value: "name",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Code"),
					value: "code",
					searchable: false,
					sortable: false,
				},

				{
					text: this.$t("Phone"),
					value: "phone",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Order Count"),
					value: "order_count",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Status"),
					value: "status",
					sortable: false,
					searchable: false,
					width: 150,
				},
				{
					text: this.$t("Description"),
					value: "description",
					searchable: false,
					sortable: false,
				},
				{
					text: this.$t("Active"),
					value: "active",
					sortable: false,
					searchable: false,
					width: 150,
					align: "right",
				},
			];
		},
	},

	methods: {
		onFilter() {
			var filter = pickBy(this.filter);
			this.$inertia.get(
				this.endpoint,
				{ filter },
				{
					preserveState: true,
					preserveScroll: true,
				}
			);
		},
		editItem(item) {
			this.$inertia.get(
				this.$route("tenant.drivers.edit", {
					tenant: this.$page.props.tenant.id,
					driver: item.uuid,
				})
			);
		},

		viewItem(item) {
			this.$inertia.get(
				this.$route("tenant.drivers.show", {
					tenant: this.$page.props.tenant.id,
					driver: item.uuid,
				})
			);
		},
		deleteItem(item) {
			this.item = Object.assign({}, item);
			this.$refs.deleteDialog.open();
		},
	},
};
</script>